// src/app/core/mainPage/mainPagecomp/TopModelsSection/mockData.ts
import type { TopModelCategoryData, LatestModelData } from '../comp/types';

export const MOCK_TEXT_MODEL: TopModelCategoryData = {
  id: 'gpt-4.1',
  name: 'GPT-4.1',
  description: 'Лучшая для сложных инструкций и длинных текстов',
  background: '', 
};

export const MOCK_IMAGE_MODEL: TopModelCategoryData = {
  id: 'dall-e-3',
  name: 'DALL·E 3',
  description: 'Генерация детализированных изображений',
  background: 'https://images.unsplash.com/photo-1682687982501-1e58ab814714?w=600', // пример AI-арта
};

export const MOCK_VIDEO_MODEL: TopModelCategoryData = {
  id: 'runway-gen3',
  name: 'Runway Gen‑3',
  description: 'Создание коротких видео по описанию',
  background: 'https://media.giphy.com/media/3o7aD2sa1QqC8GmgE8/giphy.gif', // гифка-заглушка
  isVideo: true,
};

export const MOCK_LATEST_MODEL: LatestModelData = {
  id: 'claude-3.5',
  name: 'Claude 3.5 Sonnet',
  description: 'Новейшая модель с улучшенным пониманием контекста и креативностью',
  dateAdded: '12.07.2026',
  background: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=1200', // нейросети
};